<template>
  <div
    v-on="$listeners"
    class="box box-button"
    :class="{
      selected: selected,
      'has-text-centered': centered,
      'is-disabled': disabled
    }"
  >
    <slot name="body" />
  </div>
</template>

<script>
export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'BoxButton',
  slotsDefinition: {
    body: {}
  },
  props: {
    selected: {
      type: Boolean,
      default: false
    },
    centered: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>
